import withSiteDependencies from './with-site-dependencies';

export default {
  withSiteDependencies,
};
